import React, { Component } from "react";
import "./SuccessAlert.scss";

export default class SuccessAlert extends Component {
    render() {
        return (
            <div className="position-absolute w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-success border-success success-alert animated zoomIn faster">
                <span className="fa fa-check-circle text-white check-icon"></span>
                <h4 className="text-white mt-2">{this.props.message}</h4>
                {this.props.children}
            </div>
        );
    }
}
